import {decorate, observable} from "mobx";
import {IModulator} from "./Modulator";
import modulatorsStore from "./ModulatorsStore";
// @ts-ignore
import store from "storejs";

export const LOCAL_STORAGE_KEY = "studiocode.modulators.presets";

export type PresetType = {
    name: string,
    modulators: IModulator[],
    midi_input: any,
    midi_output: any
}

class PresetsStore {

    presets: PresetType[] = [];

    selected: number = -1;
    selectedName: string = '';

    constructor() {
        this.loadPresets();
    }

    loadPresets(): void {
        // console.log('loadPresets');
        const s = store.get(LOCAL_STORAGE_KEY);
        // if (s) preferences = Object.assign(preferences, preferences, JSON.parse(s));
        this.presets = s ? JSON.parse(s) : [];
        // console.log('loadPresets', s, this.presets);
    }

    /**
     * Save all presets in local storage
     */
    savePresets() {
        // console.log("savePresets()");
        // loadPreferences();
        // Object.assign(preferences, preferences, options);
        store(LOCAL_STORAGE_KEY, JSON.stringify(this.presets));
    }

    loadPreset(index: number) {
        if (index < 0 || index >= this.presets.length) return;
        this.selected = index;
        this.selectedName = this.presets[this.selected].name;
        modulatorsStore.loadPreset(this.presets[this.selected]);
    }

    updateSelectedName(name: string) {
        this.selectedName = name;
        //if we change the name, that means this will be a new preset, so we unselected the currently selected preset
        this.selected = -1;
    }

    /**
     * Updates the current preset or save as a new one, depending if the name has been changed
     */
    savePreset() {
        if (this.selected < 0) {
            // save as new preset
            // console.log("add new preset");
            this.addPreset(this.selectedName);
            this.selected = this.presets.length - 1;
            // console.log("new preset index is", this.selected);
        } else {
            // update current preset
            this.presets[this.selected].modulators = this.getCurrentModulators();
        }
        this.savePresets();
    }

    addPreset(name: string) {
        this.presets.push({
            name: name,
            midi_input: -1,
            midi_output: -1,
            modulators: this.getCurrentModulators()
        });
    }

    getCurrentModulators(): IModulator[] {
        return modulatorsStore.modulators.map(
            (modulator, index) => modulator.getInterfaceValues()
        );
    }

}

decorate(PresetsStore, {
    presets: observable,
    selected: observable,
    selectedName: observable
});

export default new PresetsStore();
